import { computed } from '@ember/object';
import { hasMany, belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

const PLATFORMS = {
  IOS: 'ios',
  ANDROID: 'android',
};

export const USER_DEVICE = {
  PLATFORMS,
};

const UserDevice = ShModel.extend({
  userId: attr('number'),
  platform: attr('string'),
  deviceType: attr('string'),
  deviceId: attr('string'),
  model: attr('string'),
  niceName: attr('string'),
  isPushEnabled: attr('boolean'),
  updatedAt: attr('date'),

  user: belongsTo('user', { async: false }),
  deviceNotificationPreferences: hasMany('notificationPreference', {
    async: false,
    inverse: 'device',
  }),

  isIosDevice: computed('platform', function() {
    return this.get('platform') === USER_DEVICE.PLATFORM_IOS;
  }),

  isAndroidDevice: computed('platform', function() {
    return this.get('platform') === USER_DEVICE.PLATFORM_ANDROID;
  }),
});

export default UserDevice;
